import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import mainImg from "../Img/fin-home-img.png";
import AboutMainSection from "./AboutMainSection";
import CallToAction from "./CallToAction";
import WhyChooseUs from "./WhyChooseUs";
// import Associates from "./Associates";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4 } },
};

const Home = () => {
    const navigate = useNavigate();
    const loanData = [
        {
            title: "Audit & Assurance Services",
            description: "Ensuring Integrity, Transparency, and Compliance.",
            icon: "fa-search",
            link: "/audit-assurance-services-india",
        },
        {
            title: "Financial Hygiene & Managed Accounting",
            description: "Your Virtual Finance Back-Office.",
            icon: "fa-calculator",
            link: "/financial-hygiene-managed-accounting",
        },
        {
            title: <>Indian Tax Advisory <br /> (Direct & Indirect)</>,
            description: "Strategic Planning for the Modern Taxpayer.",
            icon: "fa-balance-scale",
            link: "/indian-tax-advisory",
        },
        {
            title: "Capital & Lending Solutions",
            description: "Fueling Business Growth through Smart Liquidity.",
            icon: "fa-money-bill-wave",
            link: "/loan-services-india",
        },
        {
            title: "Corporate Advisory & Virtual CFO ",
            description: "High-Level Strategic Solutions for Growing Enterprises",
            icon: "fa-briefcase",
            link: "/corporate-advisory-virtual-cfo",
        },
        {
            title: "Registration and Certifications",
            description: "Expert assistance in business registration and certifications",
            icon: "fa-certificate",
            link: "/registration-certifications",
        },
    ];

    return (
        <>
            <motion.div className="landing-section-smco" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <motion.div className="landing-container-smco landing-container-smco1" variants={scrollReveal}>
                    <motion.h1 variants={scrollReveal}>Welcome to KRS FinSolutions<span className="animate__animated animate__jackInTheBox animate__delay-1s"></span></motion.h1>
                    <motion.p variants={scrollReveal}>Your trusted partner for home loans, mortgage loans, and business loans
across the Mumbai Metropolitan Region</motion.p>
                    <button className="landing-container-cta-smco" variants={scrollReveal} onClick={() => navigate("/apply-loan-online")}>Apply Now</button>
                </motion.div>
                <motion.div className="landing-container-smco landing-container-smco2 animate__animated animate__zoomInDown animate__delay-1s" variants={scrollReveal}>
                    <motion.img src={mainImg} alt="" variants={scrollReveal} />
                </motion.div>
            </motion.div>
            {/*<motion.div variants={scrollReveal}><Associates /></motion.div> */}

            <motion.div variants={scrollReveal}><AboutMainSection /></motion.div>
            <motion.div variants={scrollReveal}><WhyChooseUs /></motion.div>
            <motion.div variants={scrollReveal}><CallToAction /></motion.div>

            <motion.div className="loan-card-main" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                    <span className="horizontal-line"></span>Our Core Services
                </motion.h2>
                <motion.p className="sections-description-smco" variants={scrollReveal}>
                    Quick approvals, low rates, and hassle-free loans tailored for you.
                </motion.p>

                <motion.div className="loan-cards-container-smco" variants={staggerContainer}>
                    {loanData.map((loan, index) => (
                        <motion.div key={index} className="loan-card-smco" variants={scrollReveal}>
                            <motion.div className="loan-card-container-icon-dashed-border" variants={scrollReveal}>
                                <motion.div className="loan-card-icon-container-smco" variants={scrollReveal}>
                                    <motion.i className={`fa-solid ${loan.icon} loan-card-icon-smco`} variants={scrollReveal}></motion.i>
                                </motion.div>
                            </motion.div>
                            <motion.h3 className="loan-card-title-smco" variants={scrollReveal}>{loan.title}</motion.h3>
                            <motion.p className="loan-card-description-smco" variants={scrollReveal}>{loan.description}</motion.p>
                            <motion.button
                                className="loan-card-button-smco"
                                variants={scrollReveal}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(loan.link);
                                }}
                            >
                                <i className="fa-solid fa-arrow-right learn-more-arrow"></i>
                            </motion.button>
                        </motion.div>
                    ))}
                </motion.div>

                <div
                    onClick={() => navigate("/Our-services")}
                    style={{ marginTop: "40px" }}
                    className="loan-card-button-smco">
                    View all services
                </div>
            </motion.div>
        </>
    );
};

export default Home;